import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export const initGoogleAuth = async () => {
  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
    hd: 'urbancompany.com'
  });
  firebase.auth().signInWithRedirect(provider);
  // const authResult = await firebase.auth().signInWithPopup(provider);
  // const idToken = authResult.credential.idToken;
  // console.log("idToken", idToken);
  // return { idToken };
}

export const getCurrentUser = () => {
  const user = firebase.auth().currentUser;
  console.log("getCurrentUser::user", user);
  return user;
}
